import React, { Component } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-power-select/dist/react-power-select.css';
export default class PortalJobSplitter extends Component {
  constructor(props) {
    super(props);
    let jobId  = $('#job-splitter-modal').data('data-job-id');
    let that = this;
    this.state = {
      isLoading: true,
      job: props.data || [],
      jobId: jobId || null,
      originalPickupAddressOnOneLine: '',
      originalDropoffAddressOnOneLine: '',
      unitsCount:props.unitsCount
    };
    this.handleCreateSplitButtonClick = this.handleCreateSplitButtonClick.bind(this);
    Echo.
    channel('jobs-table-'+jobId).
    listen('JobsTableChanged', (e) => {
      that.getJobSplittingDataForJob(jobId);
    });
  }
  handleCreateSplitButtonClick(e, jobId = null) {
    e.preventDefault();
    if (jobId == null) { return false; }
    // alert('unitsCount'+this.state.unitsCount);
    // return false;
    this.splitJob(jobId);
  }
  
  splitJob(jobId = null) {
    if (!Number.isInteger(jobId)) {
      return false;
    }
    let that = this;
    this.setState({
      isLoading:true
    });
    $.ajax({
      url: "/api/v1/portal/job-splitting/split-job/"+jobId,
      data: {api_token: window.api_token,unitsCount:this.state.unitsCount},
      cache: false,
      method: 'post',
      complete: function(response) {
        if (response.status == 200) {
          // ASSUME GOOD FOR NOW
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html(
            response.responseText.replace(/\"/g,
              "")
          );
          $('#infomodal').modal();
        }
        that.getJobSplittingDataForJob(that.state.jobId);
      }
    });
  }
  componentDidMount() {
    if (this.state.jobId) {
      this.getJobSplittingDataForJob(this.state.jobId);
    }
  }
  formatAddressAsOneLine(address, addressAsOneLine = '') {
    if (address.house_number_or_name != null) {
      addressAsOneLine = address.house_number_or_name;
      addressAsOneLine = addressAsOneLine+', ';
    }
    if (address.address_line_1 != null) {
      addressAsOneLine = addressAsOneLine+address.address_line_1;
      addressAsOneLine = addressAsOneLine+', ';
    }
    if (address.address_line_2 != null) {
      addressAsOneLine = addressAsOneLine+address.address_line_2;
      addressAsOneLine = addressAsOneLine+', ';
    }
    if (address.address_line_3 != null) {
      addressAsOneLine = addressAsOneLine+address.address_line_3;
      addressAsOneLine = addressAsOneLine+', ';
    }
    if (address.town_city != null) {
      addressAsOneLine = addressAsOneLine+address.town_city;
      addressAsOneLine = addressAsOneLine+', ';
    }
    if (address.county_area != null) {
      addressAsOneLine = addressAsOneLine+address.county_area;
      addressAsOneLine = addressAsOneLine+', ';
    }
    if (address.country != null) {
      addressAsOneLine = addressAsOneLine+address.country;
      addressAsOneLine = addressAsOneLine+', ';
    }
    if (address.postcode != null) {
      addressAsOneLine = addressAsOneLine+address.postcode;
    }
    return addressAsOneLine;
  }
  formatDriverTimeAsOneLine(preposition='', day='', month='', year='', time='') {
    return preposition+' '+day+'/'+month+'/'+year+' @ '+time;;
  }
  getJobSplittingDataForJob(jobId) {
    if (!Number.isInteger(jobId)) {
      return false;
    }
    let that = this;
      that.setState({isLoading: true});
    $.ajax({
      url: "/api/v1/portal/job-splitting/get-data-for-job/"+jobId,
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(jobDataJson) {
      that.setState({
        job: jobDataJson,
        originalPickupAddressOnOneLine: that.formatAddressAsOneLine(
          jobDataJson.pickup_address
        ),
        originalPickupTime: that.formatDriverTimeAsOneLine(
          jobDataJson.scheduled_pickup_preposition,
          jobDataJson.scheduled_pickup_day,
          jobDataJson.scheduled_pickup_month,
          jobDataJson.scheduled_pickup_year,
          jobDataJson.scheduled_pickup_time
        ),
        originalDropoffAddressOnOneLine: that.formatAddressAsOneLine(
          jobDataJson.dropoff_address
        ),
        originalDropoffTime: that.formatDriverTimeAsOneLine(
          jobDataJson.scheduled_dropoff_preposition,
          jobDataJson.scheduled_dropoff_day,
          jobDataJson.scheduled_dropoff_month,
          jobDataJson.scheduled_dropoff_year,
          jobDataJson.scheduled_dropoff_time),
        isLoading: false
      });
    });
  }

  renderSplitJobTree() {
    let i = 0;
    let splitJobStuff = [];
    let that = this;
    let iterateThroughTree = function(obj) {
      let i = 0;
      for (i = 0; i < obj.split_job_child_recursive.length; i++) {
        if (obj.split_job_child_recursive[i] !== null) {
          if (obj.split_job_child_recursive[i].split_job_child_recursive.length === 0) {
            splitJobStuff.push(
              <JobSplit
                key={'split-job-'+obj.split_job_child_recursive[i].id}
                jobId={obj.split_job_child_recursive[i].id}
                job={obj.split_job_child_recursive[i]}
                pickupAddressOnOneLine={
                  that.formatAddressAsOneLine(
                    obj.split_job_child_recursive[i].pickup_address
                  )
                }
                dropoffAddressOnOneLine={
                  that.formatAddressAsOneLine(
                    obj.split_job_child_recursive[i].dropoff_address
                  )
                }
                pickupTime={
                  that.formatDriverTimeAsOneLine(
                    obj.split_job_child_recursive[i].scheduled_pickup_preposition,
                    obj.split_job_child_recursive[i].scheduled_pickup_day,
                    obj.split_job_child_recursive[i].scheduled_pickup_month,
                    obj.split_job_child_recursive[i].scheduled_pickup_year,
                    obj.split_job_child_recursive[i].scheduled_pickup_time)
                }
                dropoffTime={
                  that.formatDriverTimeAsOneLine(
                    obj.split_job_child_recursive[i].scheduled_dropoff_preposition,
                    obj.split_job_child_recursive[i].scheduled_dropoff_day,
                    obj.split_job_child_recursive[i].scheduled_dropoff_month,
                    obj.split_job_child_recursive[i].scheduled_dropoff_year,
                    obj.split_job_child_recursive[i].scheduled_dropoff_time)
                }
                handleCreateSplitButtonClick={
                  that.handleCreateSplitButtonClick.bind(this)
                }
               />);
          }
          else {
            iterateThroughTree(obj.split_job_child_recursive[i]);
          }
        }
      }
      return null
    };

    if (this.state.job.split_job_child_recursive.length === 0) {
      splitJobStuff.push(
        <JobSplit
          key={'split-job-'+this.state.id}
          jobId={this.state.id}
          job={this.state.job}
          pickupAddressOnOneLine={
            this.formatAddressAsOneLine(this.state.job.pickup_address)
          }
          dropoffAddressOnOneLine={
            this.formatAddressAsOneLine(this.state.job.dropoff_address)
          }
          pickupTime={
            that.formatDriverTimeAsOneLine(
              this.state.job.scheduled_pickup_preposition,
              this.state.job.scheduled_pickup_day,
              this.state.job.scheduled_pickup_month,
              this.state.job.scheduled_pickup_year,
              this.state.job.scheduled_pickup_time)
          }
          dropoffTime={
            that.formatDriverTimeAsOneLine(
              this.state.job.scheduled_dropoff_preposition,
              this.state.job.scheduled_dropoff_day,
              this.state.job.scheduled_dropoff_month,
              this.state.job.scheduled_dropoff_year,
              this.state.job.scheduled_dropoff_time)
          }
          handleCreateSplitButtonClick={this.handleCreateSplitButtonClick.bind(this)}
         />);
    }
    else {
      iterateThroughTree(this.state.job);
    }
    return (
      <div className="portal-job-splitter-blocks-container">
      {splitJobStuff}
      </div>
    )
  }

  render() {
    return (
      <div>
      {this.state.isLoading ?
      (<div className="loading-box">
        <span className="add-loading-text">
          <i className="fa fa-spinner fa-pulse"></i>
        </span>
      </div>) :
        <form id="split_job_form" ref="splitJobForm" className="text-right">
          <fieldset>
            <div className="portal-job-splitter-blocks-container">
              <div className="portal-job-splitter-block portal-job-splitter-block-start portal-job-splitter-block-original-start">
                <div className="job-splitter-block-address-and-time">
                  <div>Yard Address: {this.state.originalPickupAddressOnOneLine}</div>
                  <div>Pickup {this.state.originalPickupTime}</div>
                </div>
                <div className="job-splitter-job-belongs-to-info">
                  (Original <a href={"/jobs/view/"+this.state.jobId}>Job#{this.state.jobId}</a> pickup)
                </div>
              </div>
            </div>
            {this.renderSplitJobTree()}
            <div className="portal-job-splitter-blocks-container">
              <div className="portal-job-splitter-block portal-job-splitter-block-end portal-job-splitter-block-original-end">
                <div className="job-splitter-block-address-and-time">
                  <div>Yard Address: {this.state.originalDropoffAddressOnOneLine}</div>
                  <div>Pickup {this.state.originalDropoffTime}</div>
                </div>
                <div className="job-splitter-job-belongs-to-info">
                  (Original <a href={"/jobs/view/"+this.state.jobId}>Job#{this.state.jobId}</a> dropoff)
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      }
      </div>
    )
  }
}
class JobSplit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      job: props.job || null,
      pickupAddressOnOneLine: props.pickupAddressOnOneLine || null,
      dropoffAddressOnOneLine: props.dropoffAddressOnOneLine || null,
      pickupTime: props.pickupTime || null,
      dropoffTime: props.dropoffTime || null
    }
  }
  render() {
    return (
      <div className="portal-job-splitter-blocks-container">
        <div className="portal-job-splitter-block portal-job-splitter-block-start">
          <div className="job-splitter-block-address-and-time">
            <div>Yard Address: {this.state.pickupAddressOnOneLine}</div>
            <div>Pickup {this.state.pickupTime}</div>
          </div>
          <div className="job-splitter-job-belongs-to-info">
            (<a href={"/jobs/view/"+this.state.job.id}>Job#{this.state.job.id}</a> pickup)
          </div>
        </div>

        <button className="btn btn-info btn-lg" onClick={(e) => this.props.handleCreateSplitButtonClick(e, this.state.job.id)}>
          <i className="fa fa-strikethrough"></i>plit
        </button>

        <div className="portal-job-splitter-block portal-job-splitter-block-end">
          <div className="job-splitter-block-address-and-time">
            <div>Service {this.state.dropoffTime}</div>
            <div>Service Address: {this.state.dropoffAddressOnOneLine}</div>
          </div>
          <div className="job-splitter-job-belongs-to-info">
            (<a href={"/jobs/view/"+this.state.jobId}>Job#{this.state.job.id}</a> dropoff)
          </div>
        </div>
      </div>
    )
  }
}
